const prefix = 'forms-list'

export enum FormsQueryKeys {
  Forms = `${prefix}/forms`,
  FormFolders = `${prefix}/form-folders`,
}
